import React from 'react';
import PropTypes from 'prop-types';
import { FullPetDetailsPropTypes } from '../../propTypes/petDetails';
import { getAllPolicyHolders } from '../../helpers/policyHelpers';
import { PolicyHolderDetails } from './policyHolderDetails/policyHolderDetails';

import './accountDetails.scss';

export const AccountDetails = ({ petDetails }) => {
  // TODO: Confirm the policy holder from pet details can be used
  // TODO: What happens if they are an authorised person - how do they appear in the data structures

  const allPolicyHolders = getAllPolicyHolders({ petDetails: [petDetails[0]] });
  const numPolicyHolders = petDetails.length;

  return (
    <div className="accountDetails">
      {allPolicyHolders.map((policyHolder) => (
        <PolicyHolderDetails
          policyHolder={policyHolder}
          numPolicyHolders={numPolicyHolders}
          key={`${policyHolder.email}_${policyHolder.phoneMobile}`}
        />
      ))}
    </div>
  );
};

AccountDetails.propTypes = {
  petDetails: PropTypes.arrayOf(FullPetDetailsPropTypes)
};
